import { COURSE_STEP_STATUS } from "@/utils/courseStepStatus";
import { COURSE_STEP_TYPE } from "@/utils/courseStepType";
import { getStaffIdentity, hasPermission, STAFF_ACCOUNT_TYPE, STAFF_PERMISSION } from "@/utils/staffAuth";

const STUDENT_OWNED_STEPS = new Set([
  COURSE_STEP_TYPE.ENROLMENT,
  COURSE_STEP_TYPE.IDENTITY_DOCUMENTS,
  COURSE_STEP_TYPE.USI,
  COURSE_STEP_TYPE.PRE_TRAINING_REVIEW,
  COURSE_STEP_TYPE.LLN_TEST,
  COURSE_STEP_TYPE.PRE_CLASS_PREPARATION,
  COURSE_STEP_TYPE.READING_LEARNING_PACK,
  COURSE_STEP_TYPE.READING_VICTORIAN_SAFETY,
  COURSE_STEP_TYPE.READING_WORKSAFE,
]);

const ADMIN_MANAGED_STEPS = new Set([
  COURSE_STEP_TYPE.BOOK_CLASS,
  COURSE_STEP_TYPE.ATTENDANCE,
  COURSE_STEP_TYPE.ASSESSMENT,
  COURSE_STEP_TYPE.COURSE_COMPLETED,
  COURSE_STEP_TYPE.CERTIFICATE,
]);

const stepType = (step = {}) => Number(step?.stepTypeNo ?? step?.courseStepTypeNo ?? step?.stepType ?? 0);
const stepStatus = (step = {}) => Number(step?.statusNo ?? step?.stepStatusNo ?? 0);

export function getCourseProgressPermissions({ role, step = {} }) {
  const isAdmin = String(role).toLowerCase() === "admin";
  const type = stepType(step);
  const status = stepStatus(step);
  const locked = Boolean(step.isLocked) || status === COURSE_STEP_STATUS.LOCKED;
  const completed = Boolean(step.isCompleted) || status === COURSE_STEP_STATUS.COMPLETED;
  const isLln = type === COURSE_STEP_TYPE.LLN_TEST;
  const isStudentOwned = STUDENT_OWNED_STEPS.has(type);
  const isAdminManaged = ADMIN_MANAGED_STEPS.has(type);
  const hasUrl = Boolean(step.url);
  const staff = isAdmin ? getStaffIdentity() : null;
  const hasCertificateIssuePermission = isAdmin && hasPermission(STAFF_PERMISSION.CERTIFICATE_ISSUE);
  const canManageStep = !isAdmin ? false
    : [COURSE_STEP_TYPE.ENROLMENT, COURSE_STEP_TYPE.IDENTITY_DOCUMENTS, COURSE_STEP_TYPE.USI, COURSE_STEP_TYPE.LLN_TEST].includes(type) ? hasPermission(STAFF_PERMISSION.ENROLMENT_MANAGE)
      : type === COURSE_STEP_TYPE.ATTENDANCE ? hasPermission(STAFF_PERMISSION.ATTENDANCE_MANAGE)
      : type === COURSE_STEP_TYPE.ASSESSMENT ? hasPermission(STAFF_PERMISSION.ASSESSMENT_MANAGE)
        : type === COURSE_STEP_TYPE.COURSE_COMPLETED ? hasPermission(STAFF_PERMISSION.COURSE_COMPLETE)
          : type === COURSE_STEP_TYPE.BOOK_CLASS ? hasPermission(STAFF_PERMISSION.ENROLMENT_MANAGE)
            : false;

  return {
    canView: hasUrl && (!locked || isAdmin),
    canEdit: isAdmin ? isLln && Boolean(step.adminReviewReady) && canManageStep : !locked && !completed,
    canStart: !isAdmin && !locked && !completed,
    canComplete: isAdmin ? isAdminManaged && canManageStep && !locked && !completed : !locked && !completed,
    canReview: isAdmin && isLln && canManageStep && Boolean(step.adminReviewReady),
    canIssueCertificate: hasCertificateIssuePermission && !locked && !completed,
    hasCertificateIssuePermission,
    canManageStep,
    canViewHistory: type > 0,
    isStudentOwned,
    isAdminManaged,
    isLln,
  };
}
